/**
 * dev应用内容
 */
export default {
  //构建内容
  build() {
    return [
      {
        title: 'app-businessSystem3',//中文dev
        content: [{
          name: 'dev-app-whaee-operator',//哇鹅-商家端 - Sevens运营账户入口
          id: 1,
          link: 'http://dev.console.whaee.net/v2/operator/login',
          logoColor: '#EC5830',
          img: require('@/assets/logo/whaeeLogo.png')
        }, {
          name: 'dev-app-mms',//MMS
          id: 2,
          link: 'http://dev.mms.pingworth.net',
          logoColor: '#3f48cc',
          img: require('@/assets/logo/mmsLogo.png')
        }, {
          name: 'dev-app-kpa',//KPA
          id: 3,
          link: 'http://dev.kpa.pingworth.net',
          logoColor: '#7e40c7',
          img: require('@/assets/logo/kpaLogo.png')
        }, {
          name: 'dev-app-cs',//CS
          id: 4,
          link: 'http://dev.cs.pingworth.net',
          logoColor: '#A349A4',
          img: require('@/assets/logo/csLogo.png')
        }, {
          name: 'dev-app-fms',//FMS
          id: 5,
          link: 'http://dev.fms.pingworth.net',
          logoColor: '#57000d',
          img: require('@/assets/logo/fmsLogo.png')
        }, {
          name: 'dev-app-dms',//DMS
          id: 6,
          link: 'http://dev.dms.pingworth.net',
          logoColor: '#518217',
          img: require('@/assets/logo/dmsLogo.png')
        }, {
          name: 'dev-pw-exception',//品沃异常
          id: 8,
          link: 'http://dev.ex.pingworth.net',
          logoColor: '#DDDDDD',
          img: require('@/assets/logo/pw_ex_logo.png'),
          isDeveloper: true
        }, {
          name: 'dev-pw-os',//品沃OS
          id: 9,
          link: 'http://dev.os.pingworth.net',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/pw_os_logo.png')
        },{
          name: 'dev-app-sensation',//哇鹅-红人端
          id: 10,
          link: 'http://dev.whatsworth.net',
          logoColor: '#FF3D48',
          img: require('@/assets/logo/pingworth.png')
        },{
          name: 'dev-app-store',//哇鹅-商家端
          id: 11,
          link: 'http://dev.whaee.net',
          logoColor: '#EC5830',
          img: require('@/assets/logo/whaeeLogo.png')
        },{
          name: 'dev-whaee-help',//哇鹅-帮助中心
          id: 12,
          link: 'http://dev.help.whaee.net',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/whaee_help_logo.png')
        }]
      },
      // {
      //   title: 'app-officialWebsite',//官方网站
      //   content: [{
      //     name: 'dev-app-sensation',//哇鹅-红人端
      //     id: 1,
      //     link: 'http://dev.whatsworth.net',
      //     logoColor: '#FF3D48',
      //     img: require('@/assets/logo/pingworth.png')
      //   },{
      //     name: 'dev-app-store',//哇鹅-商家端
      //     id: 2,
      //     link: 'http://dev.whaee.net',
      //     logoColor: '#EC5830',
      //     img: require('@/assets/logo/whaeeLogo.png')
      //   },{
      //     name: 'dev-whaee-help',//哇鹅-帮助中心
      //     id: 3,
      //     link: 'http://dev.help.whaee.net',
      //     logoColor: '#FFFFFF',
      //     img: require('@/assets/logo/whaee_help_logo.png')
      //   }]
      // },
      {
        title: 'devops-project-management',//项目管理
        content: [{
          name: 'devops-pingcode',//PingCode
          id: 1,
          link: 'https://pingworth.pingcode.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/pingcode_logo.png')
        },{
          name: 'devops-wiki',//产研知识库
          id: 2,
          link: 'https://nsksiwszvz.feishu.cn/wiki/',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/whaee_wiki_logo.png')
        },{
          name: 'devops-it-library',//品沃IT智库
          id: 3,
          link: 'http://it.library.pingworth.net',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/pingworth_it_library_logo.png')
        }]
      },
      {
        title: 'devops-Product-UI',//产品UI
        content: [{
          name: 'devops-yuque',//'语雀',
          id: 1,
          link: 'https://pingworth.yuque.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/yuque_logo.png')
        }, {
          name: 'devops-ui-link-navigation',//品沃UI设计链接导航
          id: 2,
          link: 'https://nsksiwszvz.feishu.cn/docx/doxcnpI6RE80lWdIgax1gQlWTec',
          logoColor: '#e5f2d5',
          img: require('@/assets/logo/pingworth-UI.png')
        }, {
          name: 'devops-lanhu',//'蓝湖',
          id: 3,
          link: 'https://lanhuapp.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/lanhu_logo.png')
        }, {
          name: 'devops-Figma',//Figma
          id: 4,
          link: 'https://www.figma.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/figma_logo.png')
        }]
      },
      {
        title: 'devops-collaboration',//开发协同
        content: [{
          name: 'devops-swagger',//Swagger API
          id: 1,
          link: 'http://dev.api.whatsworth.net/merchant/doc.html',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/swagger_fav.png')
        }, {
          name: 'devops-yapi',//'YApi',
          id: 2,
          link: 'http://yapi.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/yapi_logo.png')
        }, {
          name: 'devops-GitLab',//'GitLab',
          id: 3,
          link: 'http://git.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/gitLab_logo.png')
        }]
      },
      {
        title: 'devops-deploy-operation',//部署&运维
        content: [
          {
          name: 'devops-Jenkins',//'Jenkins',
          id: 1,
          link: 'http://dev.jenkins.whaee.net/',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/jenkins_logo.png')
        },
        {
          name: 'devops-kibana',//kibana
          id: 2,
          link: 'http://dev.kibana.whaee.net/app/discover#',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/elastic_logo.jpg')
        },{
          name: 'devops-sonarqube',//sonarqube
          id: 3,
          link: 'http://sonarqube.whaee.net/projects',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/sonarqube_logo.jpeg')
        },{
          name: 'devops-rancher',//rancher
          id: 4,
          link: 'https://rancher.whaee.net/dashboard/c/local/explorer#cluster-events',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/rancher_logo.jpg')
        },{
          name: 'devops-grafana',//grafana
          id: 5,
          link: 'http://dev.grafana.whaee.net/',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/grafana_logo.png')
        },{
          name: 'devops-document',//document
          id: 6,
          link: 'https://nsksiwszvz.feishu.cn/sheets/WfFDsRIMrhwhwltCv03cB4stnHc?sheet=K1k4XC',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/document_logo.jpg')
        }]
      },
      {
        title: 'devops-base-support',//基础支持
        content: [{
          name: 'devops-apollo',//Apollo
          id: 1,
          link: 'http://dev.apollo.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/apollo_logo.png')
        }, {
          name: 'devops-otter',//Otter
          id: 2,
          link: 'http://dev.otter.pingworth.net',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/otter_logo.png')
        }, {
          name: 'dev-xxl-job',//XXL-JOB
          id: 3,
          link: 'http://xxl-job.pingworth.net',
          logoColor: '#d2d6de',
          img: require('@/assets/logo/xxl-logo.png')
        }, {
          name: 'devEN-xxl-job',//xxl-job
          id: 4,
          link: 'http://en-xxl-job.pingworth.net',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/xxl-logo.png')
        }, {
          name: 'devops-es-head',//elasticsearch-head
          id: 5,
          link: 'http://dev.es-head.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/es-head-logo.png')
        }, {
          name: 'devops-nexus',//'nexus',
          id: 6,
          link: 'https://nexus.pingworth.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/nexus_logo.png')
        }, {
          name: "devops-dolphinscheduler", //DolphinScheduler
          id: 7,
          link: "http://10.235.138.86:12345/dolphinscheduler",
          logoColor: "#d2d6de",
          img: require("@/assets/logo/dolphinscheduler_logo.png"),
        }
        // , {
        //   name: 'devops-LAN',//'品沃局域网',
        //   id: 6,
        //   link: 'http://network.pingworth.com',
        //   logoColor: '#FFFFFF',
        //   img: require('@/assets/logo/pw_network_logo.png')
        // }
        ]
      },
      {
        title: 'dev-app-third-dev-platform',//第三方开发者平台
        content: [{
          name: 'dev-app-google-dev',//google开发者
          id: 1,
          link: 'https://developers.google.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/google_dev_logo.png')
        }, {
          name: 'dev-app-amazon-attribution',//亚马逊归因
          id: 2,
          link: 'https://advertising.amazon.com/solutions/products/amazon-attribution',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/amazon_ads_logo.png')
        }, {
          name: 'dev-app-shopify-dev',//shopify开发者
          id: 3,
          link: 'https://shopify.dev',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/shopify_dev_logo.png')
        }, {
          name: 'dev-app-tiktok-dev',//tiktok开发者
          id: 4,
          link: 'https://ads.tiktok.com/marketing_api/homepage',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/tiktok_ads_logo.png')
        }, {
          name: 'dev-app-facebook-dev',//Facebook开发者
          id: 5,
          link: 'https://developers.facebook.com',
          logoColor: '#FFFFFF',
          img: require('@/assets/logo/facebook_dev_logo.png')
        }]
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/content/content_dev_app.js